<template>
  <div v-if="pro" class="full-logo">
    <img :src="ProLogo" v-show="!white" class="light-only" />
    <img :src="ProLogoWhite" :class="{ 'dark-only': !white }" />
  </div>

  <div v-else class="full-logo">
    <img :src="Logo" v-show="!white" class="light-only" />
    <img :src="LogoWhite" :class="{ 'dark-only': !white }" />
  </div>
</template>

<script>
import Logo from '../images/cardladder-logo.svg?inline';
import LogoWhite from '../images/cardladder-logo-white.svg?inline';
import ProLogo from '../images/cardladder-pro-logo.svg?inline';
import ProLogoWhite from '../images/cardladder-pro-logo-white.svg?inline';

export default {
  props: {
    pro: Boolean,
    white: Boolean,
  },

  data() {
    return {
      Logo,
      LogoWhite,
      ProLogo,
      ProLogoWhite,
    };
  },
};
</script>

<style lang="scss" scoped>
div {
  line-height: 1;
}

img {
  width: auto;
  height: var(--logo-height, 36px);
}
</style>
